import React from "react";
import { StyledExportButton } from "./ExportButton.styled";
import exportIcon from "../../../assets/icons/export.png";

interface ExportButtonProps {
  onExport: () => void;
  disabled?: boolean;
  isExporting?: boolean;
}

const ExportButton: React.FC<ExportButtonProps> = ({
  onExport,
  disabled = false,
  isExporting = false,
}) => {
  const handleButtonClick = () => {
    if (!disabled && !isExporting) {
      onExport();
    }
  };

  return (
    <StyledExportButton
      onClick={handleButtonClick}
      disabled={disabled || isExporting}
    >
      <span>{isExporting ? "מייצא..." : "ייצוא"}</span>
      {isExporting ? (
        <div className="loading-spinner" />
      ) : (
        <img src={exportIcon} alt="export" />
      )}
    </StyledExportButton>
  );
};

export default ExportButton;
